<template>
    <section class="app-main">
        
        <el-tabs type="border-card" v-model="activeName" style="margin-top:30px;">
            <el-tab-pane  label="图片管理">
                <banner section="4" @giftBanner="giftBanner" :size="size" />
            </el-tab-pane>
            <el-tab-pane label="分类管理">
                <classify section="4" :classify.sync="classify" />
            </el-tab-pane>
            <el-tab-pane label="商品管理">
                <goods section="4" :classify="classify" />
            </el-tab-pane>
        </el-tabs>

    </section>
</template>



<script>
import Banner   from './../components/banner'
import Classify from './../components/class'
import Goods    from './../components/goods'

export default {
    components: { Banner, Classify, Goods },
    data() {
        return {
            classify: [],
            size:'',
        }
    },
    methods: {
        giftBanner(site) {
            if (site == 1) {
            this.size = "375*150";
            } else if (site == 2 || site == 3) {
            this.size = "168*90";
            } else if (site == 4) {
            this.size = "343*102";
            } else this.size = "375*150";
        },
    },
    created(){
        // this.getData()
    }
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        font-size: 16px;
    }
}
</style>
